var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMytask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 3.75C10.7463 3.75 11.8069 3.75 12.466 4.40901C13.125 5.06802 13.125 6.12868 13.125 8.25C13.125 14.25 16.125 14.25 16.125 14.25H5.42897C5.183 14.25 5.06001 14.25 4.78114 14.1774C4.50226 14.1047 4.4579 14.08 4.36919 14.0304C3.51413 13.5526 1.875 12.1307 1.875 8.25C1.875 6.12868 1.875 5.06802 2.53401 4.40901C3.19302 3.75 4.25368 3.75 6.375 3.75",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 7.5V12C1.875 14.1213 1.875 15.1819 2.53401 15.841C3.19302 16.5 4.25368 16.5 6.375 16.5H8.68208C10.8034 16.5 11.8641 16.5 12.523 15.841C12.8905 15.4735 13.0531 14.9813 13.125 14.25",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 2.625V4.875C8.625 5.22445 8.625 5.39918 8.56792 5.53701C8.4918 5.72078 8.34577 5.86679 8.16202 5.94291C8.02417 6 7.84943 6 7.5 6C7.15055 6 6.97582 6 6.83799 5.94291C6.65422 5.86679 6.50821 5.72078 6.43209 5.53701C6.375 5.39918 6.375 5.22445 6.375 4.875V2.625C6.375 2.27555 6.375 2.10082 6.43209 1.96299C6.50821 1.77922 6.65422 1.63321 6.83799 1.55709C6.97582 1.5 7.15055 1.5 7.5 1.5C7.84943 1.5 8.02417 1.5 8.16202 1.55709C8.34577 1.63321 8.4918 1.77922 8.56792 1.96299C8.625 2.10082 8.625 2.27555 8.625 2.625Z",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMytask);
export default __webpack_public_path__ + "static/media/my task.861acd98570ac35811f0ef2eb6c5bdf8.svg";
export { ForwardRef as ReactComponent };